import { 
    apiRequest,
    perjalananDinasUpdate,
    perjalananDinasApproval
} from '../../../../../../services/adapters/kepegawaian/perjalananDinasService'

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", perjalananDinasUpdate, {
            body: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", perjalananDinasApproval, {
            body: query
        }, true)
    }

}

export default UpdateRepository